 export const endpoints = {
  // Authentication endpoints
  LOGIN: '/user/public/login',

  // Admin  excel endpoints
  EXEL_ENTRIES: '/upload/admin/excel-entries',
  UPLOAD_EXCEL: '/upload/media/upload-excel',
  VALIDATE_EXCEL: '/upload/admin/validate-excel',
  DELETE_EXCEL: "/upload/admin/delete-excel",

  // Admin 
  ALL_USERS: "/user/admin/customer"
}